import { AlertCircle } from 'lucide-react';
import { ACTION_ICON_COLOR } from '../../styles';
import { NodeCategory, OutputType, type LBNodeInfo } from '../../types';
import { buildNodeData } from '../../nodeDataUtils';
import { GetAlertStatusRunStepDetail } from './GetAlertStatusRunStepDetail';
import { getAlertStatusRunStepSummary } from './getAlertStatusRunStepSummary';

export const GetAlertStatusNodeInfo: LBNodeInfo = {
  protobufNodeDataKey: 'alert_status_check',

  category: NodeCategory.ACTION,

  label: 'Get Alert Status',

  hasInput: true,

  getIcon: (size: number) => (
    <AlertCircle size={size} color={ACTION_ICON_COLOR} />
  ),

  outputType: OutputType.SINGLE,

  getSubtitle: () => 'Gets current alert status',

  getRunStepSummary: getAlertStatusRunStepSummary,

  RunStepDetailComponent: GetAlertStatusRunStepDetail,

  createDefaultNodeData: () => buildNodeData('alert_status_check', {}),
};
